export class ConnectionTimeoutOverride {
  public overrideEnabled: boolean = false;
  public webSocketConnectionTimeoutInSeconds: number = 20;
  public useAutomaticBackoff: boolean = false;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/user-preferences/connection-timeout-override.ts